"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var r=require("./HttpError.js");class t extends r.HttpError{constructor(r,t,e){super(r,"An authorisation error occurred: you are not permitted to perform this action.",t,e)}}exports.AuthorisationError=t;
//# sourceMappingURL=AuthorisationError.js.map
